import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import InputField from "../../../../components/InputField";
import api from "../../../../api/api";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import "./ViewSIAdmin.css";
 
const ViewSIAdmin = () => {
  const { id } = useParams();
  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
 
  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await api.get(`/enquiry/viewEnquiry/${id}`);
        setEnquiry(response.data);
      } catch (err) {
        console.error("Error fetching enquiry:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchEnquiry();
  }, [id]);
 
  if (loading) return <p>Loading enquiry...</p>;
  if (error) return <p>Failed to load enquiry.</p>;
  if (!enquiry) return <p>No enquiry found.</p>;
 
  return (
    <>
      <Breadcrumbs />
      <form>
        <div className="row g-3 mb-3">
          {/* Shipper Details */}
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Shipper Name"
              value={enquiry.first_shipper_name}
              disabled
              style={{ height: "80px" }}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              type="textarea"
              styleTextarea={{ resize: "none" }}
              label="Shipper Address"
              value={enquiry.first_shipper_address}
              style={{ height: "80px" }}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Consignee Name"
              value={enquiry.first_consignee_name}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              type="textarea"
              styleTextarea={{ resize: "none" }}
              label="Consignee Address"
              value={enquiry.first_consignee_address}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Notify Party 1"
              value={enquiry.notify_party_1}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Notify Party 1 Address"
              value={enquiry.notify_party_1_address}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Notify Party 2"
              value={enquiry.notify_party_2}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Notify Party 2 Address"
              value={enquiry.notify_party_2_address}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Commercial Invoice Number"
              value={enquiry.commercial_invoice_number}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Commercial Invoice Date"
              value={enquiry.commercial_invoice_date}
              disabled
            />
          </div>
 
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Net Weight"
              value={enquiry.net_weight}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="I.E.C Number"
              value={enquiry.iec_number}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              label="Gross Weight"
              value={enquiry.gross_weight}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              type="textarea"
              styleTextarea={{ resize: "none" }}
              label="Marks and Number of Packages"
              value={enquiry.marks_and_packages}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              inpcls="hgtinc"
              type="textarea"
              styleTextarea={{ resize: "none" }}
              label="Remarks"
              value={enquiry.General_Remarks}
              disabled
            />
          </div>
        </div>
 
        {/* Conditional for Switch BL */}
        {enquiry.switch_bl === "Yes" && (
          <>
            <div className="mb-3">
              <h5 className="fs-6 fw-bold">
                Please go through the shipping instructions for BL2
              </h5>
            </div>
            <div className="row g-3">
              <div className="col-sm-6 col-md-4">
                <InputField
                  inpcls="hgtinc"
                  label="Shipper Name"
                  value={enquiry.second_shipper_name}
                  disabled
                />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField
                  inpcls="hgtinc"
                  label="Shipper Address"
                  value={enquiry.second_shipper_address}
                  disabled
                />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField
                  inpcls="hgtinc"
                  label="Consignee Name"
                  value={enquiry.second_consignee_name}
                  disabled
                />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField
                  inpcls="hgtinc"
                  label="Consignee Address"
                  value={enquiry.second_consignee_address}
                  disabled
                />
              </div>
            </div>
          </>
        )}
      </form>
    </>
  );
};
 
export default ViewSIAdmin;